import ajax from '@/helpers/ajax'
import { objectKeysToCamelCase } from '@/helpers/transform-object-keys'
import { trackShareOpen } from '@/analytics/track'
import { v4 as uuid } from 'uuid'

const WEB_SHARE_MEDIUM = 'web_share'

export default {
  props: {
    sharingOptions: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      sharingOptionsCaseConverted: objectKeysToCamelCase(this.sharingOptions),
      shareClickCreated: false,
      shareClickToken: uuid()
    }
  },

  computed: {
    urlWithShareClickToken() {
      const urlObj = new URL(this.sharingOptionsCaseConverted.shareUrl)
      urlObj.searchParams.append('share', this.shareClickToken)
      return urlObj.toString()
    }
  },

  methods: {
    launchShare() {
      this.trackShareClick()

      navigator.share({
        url: this.urlWithShareClickToken,
        text: this.sharingOptionsCaseConverted.shareText
      }).catch((error) => {
        if (error.name === 'AbortError') {
          // This means the user cancelled the share. This is not a problem we need to handle.
        } else {
          // Something else went wrong. Treat this as an error.
          throw error
        }
      })
    },

    trackShareClick() {
      if (!this.shareClickCreated) {
        ajax.post({
          url: this.sharingOptionsCaseConverted.shareClicksPath,
          data: {
            token: this.shareClickToken,
            medium: WEB_SHARE_MEDIUM
          },
          successHandler: () => {
            trackShareOpen(WEB_SHARE_MEDIUM, this.sharingOptionsCaseConverted.entityType, this.sharingOptionsCaseConverted.entitySlug)
            this.shareClickCreated = true
          }
        })
      }
    }
  }
}
